module.exports = "<span class=\"icons fa fa-arrows-h clickable\" matTooltip=\"Copy card configuration to other templates for this size.\" (click)=\"showCopyHorizontalModal()\" *ngIf=\"size.cards.length > 1\"></span>\n<span class=\"icons fa fa-arrows-v clickable\" matTooltip=\"Copy card configuration to other sizes.\" (click)=\"showCopyVerticalModal()\" *ngIf=\"cardService.sizes.length > 1\"></span>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/copy-configuration/copy-to/copy-to.component.html
// module id = ../../../../../src/app/hq/cards/copy-configuration/copy-to/copy-to.component.html
// module chunks = main